// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__10cQQ","additionalInfo":"AgreementModal_additionalInfo__2zUvx"};